export default class Debouncer {
  constructor () {
    this.timer = null
  }

  clear () {
    clearTimeout(this.timer)
    this.timer = null
  }

  debounce (timeout, cb, args, self) {
    return new Promise(resolve => {
      if (this.timer) clearTimeout(this.timer)
      this.timer = setTimeout(function () {
        this.timer = null
        resolve(cb.apply(self || this, args || []))
      }.bind(this), timeout)
    })
  }
}
